<template>
    <div class="item">
        <i class="link icon" v-if="item.children !== undefined" :class="{ 'plus square outline': !item.expanded, 'minus square outline': item.expanded }" @click="togglespand"></i>
        <i class="file icon" v-else></i>
        <!--<i class="right arrow icon" v-if="selected === item"></i>-->
        <div class="content">
            <a class="header" @click="$emit('selected', item)" v-if="selected === item"><b>{{ item.display_name }}</b></a>
            <a class="header" @click="$emit('selected', item)" v-else>{{ item.display_name }}</a>
            <div class="ui list">
                <admin-menu-tree-item @selected="onSelected" :selected="selected" v-if="item.expanded" v-for="child in item.children" :item="child" :key="child.id"></admin-menu-tree-item>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'admin-menu-tree-item',

  props: ['item', 'selected'],

  methods: {
    togglespand() {
      this.item.expanded = !this.item.expanded;
    },

    onSelected(selection) {
      this.$emit('selected', selection);
    },
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/admin/AdminMenuTreeItem.vue